import React from 'react'
import { Lazyload } from '~/components'
import * as st from '~/assets/styl/ResidenceClub.module.styl'
import img from '~/assets/img/Crianca-bicicleta.jpg'
import { useLanguage } from '~/hooks'

export default function ResidenceClub() {
  const { t } = useLanguage()
  return (
    <section className={st.core}>
      <div>
        <div>
          <h2>
            <span>
              {t('ResidenceClub.title.1')} <br />
              {t('ResidenceClub.title.2')}
            </span>
          </h2>
          <div>
            <h3>{t('ResidenceClub.question')}</h3>
            <p>
              <span>{t('ResidenceClub.answer')}</span>
            </p>
          </div>
        </div>
        <Lazyload src={img} className={st.bg} />
      </div>
    </section>
  )
}
